<template>
  <section>
    <header class="mui-bar mui-bar-nav">
      <a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>
      <h1 class="mui-title">原丝</h1>
    </header>
    <nav class="mui-bar mui-bar-tab" style="padding: 0px;">
      <button class="mui-btn-blue filter-btn" id="filterbtn">
        <span class="mui-icon iconfont icon-filter" style="vertical-align: middle;"></span>
        <span style="vertical-align: middle;">筛选</span>
      </button>
    </nav>
    <div class="mui-content pd-8">
      <!--第一个-->
      <div class="flex-content">
        <div class="flex-box">
          <div class="flex-container">
            <strong>涤纶原丝</strong>
          </div>
          <div class="flex-container">
            <div class="flex-content-container">
              <div class="flex-content-label flex-4">品号:</div>
              <div class="flex-content-span">180001</div>
            </div>
            <div class="flex-content-container">
              <div class="flex-content-label">规格:</div>
              <div class="flex-content-span">50公斤/筒</div>
            </div>
          </div>
          <div class="flex-container">
            <div class="flex-content-container">
              <div class="flex-content-label flex-4">数量:</div>
              <div class="flex-content-span">1000公斤</div>
            </div>
            <div class="flex-content-container">
              <div class="flex-content-label">光泽:</div>
              <div class="flex-content-span">光泽性较强</div>
            </div>
          </div>
          <div class="flex-container">

            <div class="flex-content-container">
              <div class="flex-content-label flex-4">品种区分:</div>
              <div class="flex-content-span">涤纶</div>
            </div>
            <div class="flex-content-container">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
import
<script>
    export default {
        name: "material"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/material.vue